import script from "./form-unit-cell.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-unit-cell.vue?vue&type=script&setup=true&lang=ts"

import "./form-unit-cell.vue?vue&type=style&index=0&id=56ba100e&lang=scss"

const __exports__ = script;

export default __exports__